export enum LoadingState {
  Initial = -1,
  Loading,
  Error,
  Loaded,
}
